<template>
  <div class="main_lci_wrapper py-4">
    <div class="main_layout d-flex">
      <div :class="['cards_and_logo', { coll: hideShowSidebar }]">
        <div class="render_action">
          <img src="@/assets/new-theme/PLC-Logo.svg" alt="" />

          <img
            v-if="hideXIcon"
            @click="hideAndShowSidebar"
            role="button"
            src="@/assets/new-theme/lci/x-close.png"
            alt="x-close"
          />
        </div>
        <div v-if="hideShowSidebar == false">
          <div class="cards_wrapper" v-for="(item, i) in cardItems" :key="i">
            <LciCard :item="item"></LciCard>
          </div>
        </div>
        <div
          class="mt-5 absolute_question_mark"
          v-if="!hideXIcon"
          :class="{ make_absolute: hideShowSidebar == true }"
        >
          <div
            @click="hideAndShowSidebar"
            role="button"
            class="mark_tooltip"
            v-tooltip.top-center="`${localization('Useful tips and support')}`"
          >
            <img src="@/assets/new-theme/icons/help-circle@2x.png" alt="" />
          </div>
        </div>
      </div>
      <!-- Tabs -->
      <div class="tabs_wrapper">
        <div class="step_number_and_questions_number">
          <img
            @click="backToInstructions"
            role="button"
            src="@/assets/new-theme/icons/arrow-narrow-left-active-Button.png"
            alt=""
          />
          <span class="st_number_value"
            >{{ localization("Personal Work Profile") }} - {{ localization("Step") }} {{ this.currentTabIndex + 1 }}
          </span>
          <span class="st_questions_number">{{ currentQuestionsCount }} {{ localization("Sentences") }}</span>
        </div>
        <!-- Start Questions -->
        <div class="tabs_steps mt-4">
          <span
            v-for="tab in tabs"
            :key="tab.index"
            class="d-block step"
            :class="{ active: tab.index == currentTabIndex }"
          ></span>
        </div>
        <!-- End Questions -->
        <!-- Start Loop Collapsable Questions -->

        <div
          class="global_theme_ui_collapse main_profile_personalize_and_collapse"
        >
          <h4>
            {{ currentTabTitle }}
            <span class="d-block other_text"
              >
              {{ localization("Select the appropriate statements for each Learning Pattern.") }}

              </span
            >
          </h4>

          <el-collapse
            class="mt-3 customization_for_collapse"
            v-model="panel"
            multiple
          >
            <div
              class="main_child "
              v-for="(attribute, i) in tabs[currentTabIndex].question"
              :key="i"
              style="border : 2px solid #d0d5dd"
            >
              <el-collapse-item
                :name="`${i}`"
                class=""
                :class="{ break_section: i == 'Precision' }"
              >
                <template #title>
                  <div class="custom_header_of_collapse">
                    <img
                      src="@/assets/new-theme/attributes-images/sequence.png"
                      alt="sequence"
                      v-if="i == 'Sequence'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/precision.png"
                      alt="precision"
                      v-if="i == 'Precision'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/technical_reasoning.png"
                      alt="technical_reasoning"
                      v-if="i == 'Technical Reasoning'"
                    />
                    <img
                      src="@/assets/new-theme/attributes-images/confluence.png"
                      alt="confluence"
                      v-if="i == 'Confluence'"
                    />
                    <span class="ml-2 mr-2">{{ localization(i) }}</span>
                  </div>
                </template>
                <!-- Start Checkboxes -->
                <div class="p-3">
                  <el-collapse class="collapse_checkboxes">
                    <div v-for="(item, index) in attribute" :key="index">
                      <div
                        class="checkboxes_wrapper"
                        v-for="(val, k) in item"
                        :key="k"
                      >
                        <el-checkbox-group
                          class=""
                          v-model="selected"
                          v-if="val"
                        >
                          <el-checkbox
                            v-if="val"
                            :label="val.id"
                            @change="updateSelectedAttributes"
                            :disabled="$route.name == 'View Pwp Questions'"
                          >
                            {{ val.statement }}
                          </el-checkbox>
                        </el-checkbox-group>
                        <audio controls id="audio" class="d-none">
                          <source id="audio-source" type="audio/mp3" />
                        </audio>
                        <span
                          class="span_img_wrapper hide_element_while_printing"
                          role="button"
                          @click="text_speech_audio(val.statement)"
                        >
                          <img
                            src="@/assets/new-theme/attributes-images/volume.png"
                            alt="volume"
                          />
                        </span>
                      </div>
                    </div>
                  </el-collapse>
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>

          <!-- Start Buttons For Next And Previous -->
          <div class="mt-5 d-flex justify-content-center ">
            <button
              v-if="currentTabIndex > 0"
              @click="prevTab"
              class="prev_next"
            >
              <img
                src="@/assets/new-theme/icons/arrow-narrow-left-active-Button.png"
                alt="edit icon"
              />
            </button>
            <button
              @click="nextTab"
              v-if="currentTabIndex < tabs.length - 1 && $route.name != 'View Pwp Questions'"
              class="lci_btn save mx-4"
            >
              {{ localization("Save and Continue") }}
            </button>

            <button
              @click="nextTab"
              v-if="currentTabIndex < tabs.length - 1"
              :class="$route.name == 'View Pwp Questions' ? 'prev_next ml-1' : 'prev_next'"
            >
              <img
                src="@/assets/new-theme/icons/arrow-narrow-left-active-Button.png"
                alt="edit icon"
                class="flip-horizontal"
              />
            </button>
            <button
              v-if="currentTabIndex === tabs.length - 1 && $route.name != 'View Pwp Questions'"
              class="lci_btn save  mx-4"
              @click="redirectToCareerPage"
            >
              {{ localization("Get started") }}

            </button>
          </div>
        </div>
        <!-- End Loop Collapsable Questions -->
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "Pwp Questions",
  data() {
    return {
      hideShowSidebar: false,
      hideXIcon: true,
      cardItems: [
        {
          src: require("@/assets/new-theme/pwp-1.png"),
          title: this.localization("Career matching"),
          description: this.localization("Understanding your behaviors and career goals provides us with insights to suggest personalized strategies that helps you in career opportunity.")
        },
        {
          src: require("@/assets/new-theme/pwp-2.png"),
          title: this.localization("Take the time you need"),
          description:
            this.localization("While there are no right or wrong answers, there are answers that are more accurate to who you are.")
        },
        {
          src: require("@/assets/new-theme/pwp-3.png"),
          title: this.localization("Be accurate and detailed"),
          description:
            this.localization("Try to be as accurate and detailed as possible when selecting your answer.")
        }
      ],
      tabs: [],
      active: 0,
      activeTabs: [0],
      currentTab: 0,
      // panel: [],
      currentTabIndex: 0,
      panel: [`Precision`, `Sequence`, "Technical Reasoning", "Confluence"],
      selected: []
    };
  },

  computed: {
    careerMatchStatementsQuestions() {
      return this.$store.state.user.careerMatchStatementsQuestions;
    },
    mainUserId() {
      return this.auth().id;
    },
    currentTabTitle() {
      return this.tabs[this.currentTabIndex] ? this.tabs[this.currentTabIndex].title : 'Loading...';
    },
    currentQuestionsCount() {
      const currentTab = this.tabs[this.currentTabIndex];
      if (!currentTab || !currentTab.question) return 0;

      let count = 0;
      const questions = currentTab.question;

      // Loop through each category (Precision, Technical Reasoning)
      Object.keys(questions).forEach(category => {
        // Loop through each classification (Use First)
        Object.keys(questions[category]).forEach(classification => {
          // Get the array of items in this classification
          const items = questions[category][classification];
          if (Array.isArray(items)) {
            count += items.length;
          }
        });
      });

      return count;
    }
  },
  methods: {
  redirectToCareerPage(){
    if (this.isValid()) {
        this.$router.push('/new-theme/career');
      } else {
        Swal.fire({
          text: `Please select at least one statement for each Learning Pattern.`,
          type: "error",
          icon: "error",
          confirmButtonText: `${this.localization("Ok")}`,
          confirmButtonClass: "btn btn-success ",
          buttonsStyling: false
        });
      }
  },
    hideAndShowSidebar() {
      this.hideShowSidebar = !this.hideShowSidebar;
      this.hideXIcon = !this.hideXIcon;
    },
    refresh(query) {
      this.$store
        .dispatch("user/handlerCareerMatchStatementsQuestions", {
          query: query
        })
        .then(res => {
          this.tabs = Object.entries(res.my_statements).map(
            ([title, question], index) => ({
              index: index,
              title,
              question
            })
          );
        });
    },
    isActive(index) {
      return this.activeTabs.includes(index);
    },
    updatePanel(index) {
      // Update the panel array with the keys of the selected question's content
      this.currentTabIndex = index;
      // this.panel = Object.keys(this.tabs[index].question);
    },
    switchTab(index) {
      // this.updatePanel(index);
    },
    // nextTab() {
    //   if (this.isValid()) {
    //     this.currentTabIndex++;
    //     window.scrollTo(0, 0);
    //   } else {
    //     Swal.fire({
    //       text: `Please select at least one option.`,
    //       type: "error",
    //       icon: "error",
    //       confirmButtonText: `${this.localization("Ok")}`,
    //       confirmButtonClass: "btn btn-success ",
    //       buttonsStyling: false
    //     });
    //   }
    // },

    nextTab() {
      if (this.isValid()) {
        this.currentTabIndex++;
        window.scrollTo(0, 0);
      } else {
        Swal.fire({
              text: `Please select at least one statement for each Learning Pattern.`,
              type: "error",
              icon: "error",
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
      }
    },
    isValid() {
      const currentTab = this.tabs[this.currentTabIndex];

      // Ensure currentTab and its questions exist
      if (!currentTab || !currentTab.question || typeof currentTab.question !== 'object') {
        return false;
      }

      // Check that at least one statement is selected per Learning Pattern
      return Object.keys(currentTab.question).every((pattern) => {
        const attributes = currentTab.question[pattern];

        if (!attributes || typeof attributes !== 'object') return false;

        return Object.values(attributes).some((items) => {
          if (!Array.isArray(items)) return false;

          return items.some((item) => this.selected.includes(item.id));
        });
      });
    },

    prevTab() {
      this.currentTabIndex--;
    },
    getMainUserData() {
      this.$store.dispatch("user/user", this.mainUserId).then(res => {
        if (
          res.user.my_career_statements &&
          res.user.my_career_statements != null &&
          res.user.my_career_statements != false
        ) {
          this.selected = JSON.parse(res.user.my_career_statements);
        } else {
          this.selected = [];
        }
      });
    },
    updateSelectedAttributes() {
      console.log('this.selected',this.selected);

      this.$store
        .dispatch("attributes/updateCareerMatchStatements", {
          id: this.mainUserId,
          query: { my_career_statements: this.selected }
        })
        .then(() => {
          // this.refresh();
          // this.getMainUserData();
        });
    },
    text_speech_audio(any_text) {
      this.$store
        .dispatch("user/get_text_to_speech_audio", { text: any_text })
        .then(res => {
          let audioBlob = new Blob([res], { type: "audio/mpeg" });
          let audioURL = URL.createObjectURL(audioBlob);
          let audio = document.getElementById("audio");
          var source = document.getElementById("audio-source");
          source.src = audioURL;
          audio.load();
          audio.play();
        });
    },
    getKey(any_key) {
      return any_key;
    },
    backToInstructions() {
      this.$router.push("/new-theme/pwp");
    }
  },
  mounted() {
    this.refresh();
    this.getMainUserData();
  }
};
</script>

<style lang="scss" scoped>
.other_text {
  color: #667085;
  font-size: 14px;
}
.main_lci_wrapper {
  width: 100%;

  .render_action {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .main_layout {
    gap: 40px;
  }
  .cards_and_logo {
    background: #fcfcfd;
    max-width: 25%;
    min-width: 25%;
    position: relative;
    .absolute_question_mark {
      position: fixed;
      left: 10px;
      top: 82%;
      &.make_absolute {
        position: absolute;
        bottom: 0;
      }
    }
    .cards_wrapper {
      margin-top: 40px;
    }
  }
  // Tabs
  .tabs_wrapper {
    flex-grow: 1;
    // background: #eee;
    .step_number_and_questions_number {
      display: flex;
      align-items: center;
      gap: 10px;
      .st_number_value {
        color: #101828;
        font-size: 22px;
        font-weight: 500;
      }
      .st_questions_number {
        color: #667085;
        font-size: 14px;
      }
    }
    .tabs_steps {
      display: flex;
      justify-content: space-between;
      gap: 30px;
      .step {
        height: 4px;
        border-radius: 8px;
        background-color: #e9d7fe;
        flex-grow: 1;
        // width: 180px;
        &.active {
          background-color: #7f56d9;
        }
      }
    }
  }
}
// Buttons Next And Previous
.lci_btn {
  background-color: #f2f4f7;
  color: #667085;
  border-radius: 8px;
  padding: 12px 20px;
  border: 1px solid #eaecf0;
  width: 240px;
  &.save {
    background-color: #7f56d9;
    color: #fff;
  }
}
.prev_next {
  background-color: #f2f4f7;
  border-radius: 8px;
  padding: 12px 20px;
  border: 1px solid #eaecf0;
  color: #667085;
  width: 70px;
}
.mark_tooltip {
  border: 1px solid #d0d5dd;
  width: fit-content;
  padding: 12px;
  border-radius: 50%;
}
</style>

<style lang="scss">
.main_profile_personalize_and_collapse {
  .el-collapse {
    border: none !important;
  }
  .el-collapse-item__content {
    box-shadow: none !important;
    border: none !important;

    // @media print {
    //   padding-bottom: 0;
    // }
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    font-size: 16px;
    line-height: inherit;
    color: #344054 !important;
  }
  .el-checkbox__inner {
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    height: 20px;
    width: 20px;
  }
  .el-checkbox {
    align-items: flex-start;
    display: flex;
  }
  .el-checkbox__label,
  .el-checkbox is-checked {
    color: #344054 !important;
    font-weight: 400;
    font-size: 16px;

    // max-width: 98%;
    word-break: break-word !important;
    white-space: pre-wrap;
    // word-wrap: break-word;
    white-space: normal;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #6941c6;
    border-color: #6941c6;
  }
  .el-checkbox__inner::after {
    left: 7px;
    top: 4px;
    border-width: 2px;
  }
}
</style>

<style lang="scss" scoped>
.main_lci_wrapper {
  width: 100%;
  height: 100vh;
  position: relative;

  @media (max-width: 768px) {
    height: auto;
    overflow-y: auto;
  }

  .render_action {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  // background: #eee;
  width: 100%;
  .main_layout {
    gap: 40px;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    
    @media (max-width: 768px) {
      flex-direction: column;
      position: relative;
      gap: 20px;
    }
  }

  .cards_and_logo {
    background: #fcfcfd;
    max-width: 20%;
    padding: 26px 16px;
    min-width: 21%;
    position: relative;
    // transition: 0.2s;
    
    @media (max-width: 768px) {
      max-width: 100%;
      min-width: 100%;
      padding: 15px 10px;
    }

    .absolute_question_mark {
      &.make_absolute {
        position: absolute;
        bottom: 0;
      }
    }
    .cards_wrapper {
      margin-top: 40px;
      
      @media (max-width: 768px) {
        margin-top: 20px;
      }
    }
  }
  .coll {
    background: #fff;
    padding: 26px 16px;
    min-width: 12%;
    transition: 0.8s;
    
    @media (max-width: 768px) {
      min-width: 100%;
    }
  }
  .tabs_wrapper {
    flex-grow: 0.5;
    
    @media (max-width: 768px) {
      padding: 0 15px;
    }
    // display: grid;
    // align-content: center;
    // background: #eee;
    .step_number_and_questions_number {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 2rem 0 0.75rem;
      flex-wrap: wrap;
      .st_number_value {
        color: #101828;
        font-size: 22px;
        font-weight: 500;
        @media (max-width: 576px) {
          font-size: 16px;
        }
      }
      .st_questions_number {
        color: #667085;
        font-size: 14px;
      }
    }
    .tabs_steps {
      display: flex;
      gap: 9px;
      justify-content: space-between;
      @media (max-width: 576px) {
        gap: 4px;
      }
      .step {
        height: 4px;
        border-radius: 8px;
        background-color: #e9d7fe;
        flex: 1; /* Automatically fill width appropriately */
        &.active {
          background-color: #7f56d9;
        }
      }
    }
    .all_questions {
      margin-top: 24px;
      .every_question {
        margin-bottom: 25px;
        .question_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .main_title {
            color: #344054;
            font-weight: 400;
            font-size: 17px;
            flex-grow: 1;
            max-width: 70%;
          }
          .main_icons {
            display: flex;
            gap: 30px;
            align-items: center;
            .every_icon {
              display: flex;
              gap: 7px;
              align-items: center;
              color: #7f56d9;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
.main_radio_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  // flex-wrap: wrap;
}
::v-deep .el-radio-button {
  // border: 1px solid #d0d5dd;
  // width: 100%;
  min-width: 180px;
  max-width: 200px;
  border-radius: 8px !important;
  &.is-active {
    .el-radio-button__inner {
      background: #7f56d9;
      border-color: #7f56d9;
      border-radius: 8px !important;
    }
  }
}
::v-deep .el-radio-button__inner {
  width: 100%;
  border-radius: 8px !important;
  border: 0;
  border: 1px solid #d0d5dd;
  color: #344054;
  font-weight: 500;
}

.lci_btn {
  background-color: #f2f4f7;
  color: #667085;
  border-radius: 8px;
  padding: 10px 10px;
  border: 1px solid #eaecf0;
  width: 200px;
  
  @media (max-width: 576px) {
    width: 60%;
  }

  &.save {
    background-color: #7f56d9;
    color: #fff;
  }
}
.prev_next {
  background-color: #f2f4f7;
  border-radius: 8px;
  padding: 12px 20px;
  border: 1px solid #eaecf0;
  color: #667085;
  width: 70px;
  
  @media (max-width: 576px) {
    padding: 12px 10px;
  }
}

.mark_tooltip {
  border: 1px solid #d0d5dd;
  width: fit-content;
  padding: 12px;
  border-radius: 50%;
}

.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lci_btn_modal_cancel {
  background-color: #fff;
  color: #667085;
  border-radius: 8px;
  padding: 12px 20px;
  border: 1px solid #eaecf0;
  width: 240px;
}

.dialog_style {
  .title {
    color: #101828;
    font-weight: 500;
    font-size: 20px;
  }
  .desc {
    color: #667085;
    font-weight: 400;
    font-size: 14px;
  }
  .desc2 {
    color: #344054;
    font-weight: 500;
    font-size: 16px;
  }
  .text_area {
    border: 1px solid #d0d5dd;
    height: 92px;
    width: 100%;
    resize: none;
    border-radius: 8px;
    color: #101828;
    padding: 15px;
    outline: none;
    word-break: break-word;
  }

  .img_radius {
    background: #f9f5ff;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.footer-buttons {
  bottom: 1rem;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  box-shadow: 0 -5px 2px 0 rgba(0, 0, 0, 0.025);
  z-index: 10;
  background: #ffff;
}
.step-buttons {
  padding: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

/* Step button container styles */
.step-buttons {
  display: flex;
  gap: 16px; /* Space between buttons */
}

/* Back Button Styling */
.back-btn {
  background-color: #f9fafb;
  color: #000;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-weight: 500;
  padding: 8px 16px;
  box-shadow: none;
  transition: all 0.3s ease;
}
.back-btn:hover {
  background-color: #5e3cba;
  color: #fff;
}

/* Continue Button Styling */
.continue-btn {
  background-color: #e5e7eb;
  color: #667085;
  border: 0;
  border-radius: 8px;
  font-weight: 500;
  padding: 8px 4rem;
  box-shadow: none;
  transition: all 0.3s ease;
}
.continue-btn:hover {
  background-color: #5e3cba;
  color: #fff;
}
::v-deep .el-radio-button__inner{
  white-space: unset !important;
  padding: 12px 6px !important;
}
</style>
